import React, { useEffect, useState } from 'react';
import styles from './ErrorTip.module.scss';
import errorIcon from '@/assets/icons/errorIcon.webp';
// import successIcon from '@/assets/icons/successIcon.webp';
// import warningIcon from '@/assets/icons/warningIcon.webp';

const iconMap = {
  error: errorIcon,
  //   success: successIcon,
  //   warning: warningIcon,
};

const ErrorTip = ({ message, type = 'error' }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setIsVisible(true);
    }
  }, [message]);

  if (!message || !isVisible) return null;

  return (
    <div className={`${styles.errorTip} ${styles[type]}`}>
      <img src={iconMap.error} alt={type} />
      {message}
    </div>
  );
};

export default ErrorTip;
